import React from 'react'
import { getSettings } from '../../util/getSettings';

function PriceWrapper({
    startingPrice,
    isFHA,
    isMortCalcEnabled,
    zipCode,
    downPaymentPercentage,
    hoaDues,
    priceOverrideText
}) {
    const labels = getSettings(['century', 'labels'], true);
    const settings = getSettings(['century', 'settings'], true);
    const startPrice = Math.round(startingPrice)

    async function openCalc(listPrice, zipCode, hoaDues) {

        let config = {};

        if (isFHA) {
            config = {
                list_price: listPrice,
                loan_type: "FHA",
                down_payment: listPrice * downPaymentPercentage,
                zipcode: zipCode,
                hoaDues
            };
        } else {
            config = {
                list_price: listPrice,				
                loan_type: "conventional",				
                down_payment: listPrice * downPaymentPercentage,
                zipcode: zipCode,
                hoaDues
            };
        }

        BB.api.setConfig(config)
        BB.api.openModal('mortgageCalc')
    }

    return (
        <div className='price-wrapper text-right'>
            {startPrice > 0 && (
                <>
                    <span className='start-from'>{labels.homesFromLabel}</span>
                    {isMortCalcEnabled && settings.disableBankingBridgeCalculatorModal != 'true' && window.bbReady ? (
                        <button className="price" onClick={() => openCalc(startPrice, zipCode, hoaDues)}>
                            ${startPrice.toLocaleString()}
                        </button>
                    ) : (
                        <span className='price'>${startPrice.toLocaleString()}</span>
                    )}
                </>
            )}
            {startPrice === 0 && <span className='price-override'>{priceOverrideText}</span>}
        </div>
    )
}

export default PriceWrapper